module.exports = __webpack_public_path__ + "img/logo.dfd7f45c.png";